export default __webpack_public_path__ + "static/media/icon-card-maintenance-warnings.327fbfb3.svg";